import React, { useState, useRef, useEffect } from "react";
import {
  Alert,
  Button,
  Col,
  Form,
  Row,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch } from "react-redux";
import { withNamespaces } from "react-i18next";
import CreateTextInput from "./CreateTextInput";
import CreateSearchableDropdown from "./CreateSearchableDropdown";
import CreateTextArea from "./CreateTextArea";
import CreateLink from "./CreateLink";
import CreateTabs from "./CreateTabs";
import CreateAccordion from "./CreateAccordion";
import CreateMultipleFileInput from "./CreateMultipleFileInput";
import CreateCalculosCusto from "./CreateCalculosCusto";
import Messages from "~/components/Messages";
import { handleButtonClick, handleButtonFormdata } from "../utils/FormButtons";
import { postIflowFormData } from "~/store/ducks/processes/actionTypes";
import { setConfirmProcessMessage } from "~/store/ducks/iflow/actionTypes";
import { transformFormData, hasLinks } from "../utils";
import uuid from "uuid/v1";
import oauth from "~/utils/oauth";
import CreateRowFromColumns from "./CreateRowFromColumns";
import CreateBootstrapTable from "./CreateBootstrapTable";
import CreateDateInput from "./CreateDateInput";
import CreateButtonsFromSelection from "./CreateButtonsFromSelection";
import CreateRichText from "./CreateRichText";
import CreateAlert from "./CreateAlert";
import CreateTextLabel from "./CreateTextLabel";
import CreateGoogleMap from "./CreateGoogleMap";
import CreateConfirmationModal from "./CreateConfirmationModal";
import CreateCloseProcessButton from "./CreateCloseProcessButton";
import { setFocusElement } from "~/store/ducks/iflow/actionTypes";

const RenderForm = (props) => {
  const { t } = props;
  const dispatch = useDispatch();
  const jsonData = props.data;
  const styleSheet = props.styleSheet;
  const buttonOperation = useRef(null);
  const signRef = useRef([]);
  const buttonId = useRef(null);
  const formDataRef = useRef(null);

  const [validated, setValidated] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [firstHeader, setFirstHeader] = useState(true);
  
  const listEntries = JSON.parse(localStorage.getItem('LIST_ENTRIES')) || [];
  const listEntriesReload = JSON.parse(localStorage.getItem('LIST_RELOAD_ENTRIES')) || [];

  const handleButtonDetails = (button) => {
    buttonOperation.current = button.operation;
    buttonId.current = button.id;
  };

  const handleCancelSubmit = () => {
    buttonOperation.current = null;
    buttonId.current = null;
    dispatch(setConfirmProcessMessage(null));
  };

  const handleConfirm = () => {
    setIsConfirmed(true);
    dispatch(setConfirmProcessMessage(null));
  };

  useEffect(() => {
    if (isConfirmed) {
      document.getElementById(buttonId.current).click();
    }
  }, [isConfirmed]);

  useEffect(() => {
    if (
      (listEntriesReload != null || listEntriesReload != undefined) &&
      listEntriesReload.length > 1
    ) {
      listEntriesReload.pop();
      localStorage.setItem(
        "LIST_RELOAD_ENTRIES",
        JSON.stringify(listEntriesReload)
      );
    }
    const performanceEntries = window.performance.getEntries();
    for (let i = performanceEntries.length - 1; i >= 0; i--) {
      const entry = performanceEntries[i];
      if (entry.name.includes("iFlow/Form/detail.jsp") && entry.entryType == "resource" && (entry.name.includes('&procStatus=0') || entry.name.includes('&procStatus=1') || entry.name.includes('&procStatus=2'))) {
        if (!listEntriesReload.includes(entry.name) && listEntriesReload.length < 1) {
          listEntriesReload.push(entry.name);
          localStorage.setItem(
            "LIST_RELOAD_ENTRIES",
            JSON.stringify(listEntriesReload)
          );
        }
      }
    }
    localStorage.removeItem("selectedFilesMetadata")
  }, []);

  useEffect(() => {
    const lastUrlforDispatch = localStorage.getItem("URL_LastEntry");
    if (lastUrlforDispatch != null) {
      let newreloadentrie = []
      let formDataBackButton = new FormData();
      const url = lastUrlforDispatch.split("/iFlow")[1];
      if (formDataRef.current) {
        formDataBackButton = formDataRef.current;
        const pairs = handleButtonFormdata(buttonOperation.current);
        pairs.forEach((p) => {
          formDataBackButton.delete(p.formkey);
          formDataBackButton.append(p.formkey, p.value);
        });
      } else {
        handleButtonClick(buttonOperation.current);
        formDataBackButton = transformFormData(
          new FormData(document.getElementsByName("dados")[0])
        );
      }
      if (listEntries.length < 1) {
        localStorage.removeItem('LIST_ENTRIES')
        localStorage.removeItem('LIST_RELOAD_ENTRIES')
        newreloadentrie.push(lastUrlforDispatch);
        localStorage.setItem("LIST_RELOAD_ENTRIES", JSON.stringify(newreloadentrie))
      }
    }
    localStorage.removeItem("URL_LastEntry");
  }, [buttonOperation, formDataRef, dispatch]);

  const handleSubmitWrapper = (event, button) => {
    if (window.location.href.includes("procdetail/cma/iFlow/Form/detail.jsp")) {
      procDetailClick();
    } else {
      if (isConfirmed) {
        handleSubmit(event);
      } else {
        handleButtonDetails(button);
        if (buttonOperation.current.includes("if (confirm")) {
          const array = buttonOperation.current.split("if (confirm('");
          if (array) {
            const array2 = array[1].split("'");
            if (array2) {
              dispatch(setConfirmProcessMessage(array2[0]));
              const formdata = transformFormData(
                new FormData(document.getElementsByName("dados")[0])
              );
              formDataRef.current = formdata;
            }
          }
        } else {
          handleSubmit(event);
        }
      }
    }

    dispatch(setFocusElement(null));
  };

  const procDetailClick = () => {
    if (listEntries != null) {
      let baseUrl = window.location.href;
      let lastElement;
      const index = baseUrl.indexOf("/iFlow");
      let dispactURL
      listEntries.pop();
      localStorage.setItem("LIST_ENTRIES", JSON.stringify(listEntries));

      if (listEntries.length < 1) {
        dispactURL = listEntriesReload[0]
      } else {
        lastElement = listEntries[listEntries.length - 1];
        if (index !== -1) {
          const partialUrl = baseUrl.substring(index + 6); // +7 para incluir "/iFlow/" na string
          dispactURL = baseUrl.replace(partialUrl, lastElement);
        }
      }
      const newFlowId = dispactURL.split(/flowid=([^&]*)/)[1];
      const newPid = dispactURL.split(/pid=([^&]*)/)[1];
      baseUrl = baseUrl.replace(/flowid=\d+/, `flowid=${newFlowId}`);
      baseUrl = baseUrl.replace(/pid=\d+/, `pid=${newPid}`);

      localStorage.setItem("URL_LastEntry", dispactURL);
      window.location.href = baseUrl;
      window.location.reload();
    }
  };

  const handleSubmit = (event) => {
    const form = document.dados;

    const handleDispatch = ( penultimateEntry) => {
      let formdata;
      console.log(buttonOperation.current);
      if (formDataRef.current) {
        formdata = formDataRef.current;
        console.log(formDataRef.current)
        const pairs = handleButtonFormdata(buttonOperation.current);
        pairs.forEach((p) => {
          formdata.delete(p.formkey);
          formdata.append(p.formkey, p.value);
        });
      } else {
        handleButtonClick(buttonOperation.current);
        formdata = transformFormData(
          new FormData(document.getElementsByName("dados")[0])
        );
      }

      for (var pair of formdata.entries()) {
        console.log(pair[0] + ": " + pair[1]);
      }
      let action;
      if (jsonData?.form?.action === "proc_detail.jsp") {
        action = "/proc_detail.jsp?";
      }
      //TEST NEW FORM ACTION
      else if (jsonData?.form?.action === "forward.jsp") {
        action = "/Forward/forward.jsp?";
      } else if(jsonData?.form?.action === "detail.jsp"){
        action = "/Form/detail.jsp?";
      } else {
        action = "/Form/form.jsp?";
      }
      let url  =
          `${action}` +
          "flowid=" +
          formdata.get("flowid") +
          "&pid=" +
          formdata.get("pid") +
          "&subpid=" +
          formdata.get("subpid") +
          //+ "&flowExecType=" + formdata.get("flowExecType")
          "&Authorization=" +
          oauth.getAccessToken();

      console.log(formdata, url);
      dispatch(postIflowFormData(formdata, url));
    };



    if (
      buttonOperation.current &&
      buttonOperation.current.includes("CheckEmptyFields()")
    ) {
      console.log(form.checkValidity());
      if (form.checkValidity() === false) {
        setValidated(true);
      } else {
        handleDispatch();
      }
    } else {
      if (buttonOperation.current) {
        handleDispatch();
      }
    }
  };

  const getFlowId = () => {
    return jsonData?.form?.hidden?.find((i) => i.name === "flowid")?.value;
  };

  function renderTooltip(text, ...props) {
    return (
      <Tooltip id="button-tooltip" {...props}>
        {text}
      </Tooltip>
    );
  }

  const renderColumnDivisions = (blockdivision, mainindex) => {
    const renderFields = (field, index) => {
      if (field.variable === "googlemapsapi") {
        return <CreateGoogleMap key={index} field={field} />;
      }

      if (field.type === "header") {
        if (index === 0) {
          return <></>;
        } else {
          return (
            <div
              className="custom-title"
              style={{
                backgroundColor: "#D5E0F3",
                marginBottom: "30px",
                paddingLeft: "10px",
                paddingRight: "10px",
                paddingTop: "5px",
                paddingBottom: "5px",
                borderRadius: "5px",
              }}
              key={uuid()}
            >
              {field.text.includes(":") ? field.text : t(field.text)}
            </div>
          );
        }
      } else if (field.type === "subheader") {
        return (
          <div key={uuid()}>
            <Form.Group
              controlId={`formlabel-${field.type}`}
              // style={{
              //   flexWrap: "nowrap",
              //   marginLeft: "0px",
              //   marginRight: "0px",
              //   marginBottom: "0px",
              //   flexGrow: "1",
              // }}
            >
              <Form.Label column>
                <div
                  style={{
                    backgroundColor: "#F1EBEB",

                    paddingLeft: "10px",
                    paddingRight: "10px",
                    paddingTop: "5px",
                    paddingBottom: "5px",
                    borderRadius: "5px",
                  }}
                  className="custom-title"
                >
                  {field.text.includes(":") ? field.text : t(field.text)}
                </div>
              </Form.Label>
            </Form.Group>
            {/* <hr /> */}
          </div>
        );
      } else if (field.type === "arraytable") {
        return (
          <CreateBootstrapTable
            field={field}
            key={index}
            signRef={signRef}
            styleSheet={styleSheet}
          />
        );
      } else if (field.type === "textmessage") {
        return (
          <CreateAlert key={index} index={index} field={field} variant="info" />
        );
      } else if (field.type === "textlabel") {
        return (
          <CreateTextLabel key={index} field={field} styleSheet={styleSheet} />
        );
      } else if (field.type === "link") {
        return (
          <CreateLink key={field.text} field={field} styleSheet={styleSheet} />
        );
      } else if (field.type === "textbox") {
        return (
          <CreateTextInput
            key={field.variable}
            field={field}
            styleSheet={styleSheet}
          />
        );
      } else if (field.type === "selection") {
        if (field.variable === "seccao")
          return <CreateButtonsFromSelection key={index} field={field} />;
        else
          return (
            <CreateSearchableDropdown
              key={field.variable}
              field={field}
              styleSheet={styleSheet}
            />
          );
      } else if (field.type === "datecal") {
        return (
          <CreateDateInput
            key={field.variable}
            field={field}
            styleSheet={styleSheet}
          />
        );
      } else if (field.type === "textarea") {
        if (
          (typeof field?.text == "string" &&
            field?.text?.includes("::richText")) ||
          field?.text?.b?.includes("::richText")
        ) {
          return (
            <CreateRichText
              key={field.variable}
              field={field}
              styleSheet={styleSheet}
            />
          );
        } else
          return (
            <CreateTextArea
              key={field.variable}
              field={field}
              styleSheet={styleSheet}
            />
          );
      } else if (field.type === "file") {
        return (
          <CreateMultipleFileInput
            key={index}
            field={field}
            signRef={signRef}
            styleSheet={styleSheet}
          />
        );
      } else if (field.type === "custo") {
        return <CreateCalculosCusto key={index} field={field} />;
      } else if (field.type === "button") {
        const fitbutton = field.text.includes("::fitbutton") ? true : false;
        return (
          <>
            {styleSheet?.linkAsButtons ? (
              //   <OverlayTrigger
              //   placement="top"
              //   delay={{ show: 250, hide: 400 }}
              //   overlay={renderTooltip(button.tooltip)}
              // >

              //     {button.text}
              //   </Button>

              //   <OverlayTrigger
              //   placement="top"
              //   delay={{ show: 250, hide: 400 }}
              //   overlay={renderTooltip(button.tooltip)}
              // >
              <button
                className="custom-button btn btn-outline-primary"
                style={{
                  margin: "10px",
                  minHeight: "30px",
                  padding: fitbutton ? "auto" : "0 5px 0 5px",
                  marginTop: fitbutton ? "3rem" : "0",
                }}
                type="submit"
                name={field.name}
                onClick={() => handleButtonDetails(field)}
              >
                {t(field.text.split("::")[0])}
              </button>
            ) : (
              // </OverlayTrigger>
              <Form.Group
                as={Row}
                key={uuid()}
                style={{ marginRight: "0px", marginLeft: "0px" }}
              >
                <Form.Label
                  column
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    padding: fitbutton ? "auto" : "0",
                    marginTop: fitbutton ? "3rem" : "0",
                  }}
                >
                  <Button
                    className="card-button"
                    style={{ width: fitbutton ? "100%" : "" }}
                    type="submit"
                    name={field.name}
                    onClick={() => handleButtonDetails(field)}
                  >
                    {t(field.text.split("::")[0])}
                  </Button>
                </Form.Label>
              </Form.Group>
            )}
          </>
        );
      }
    };

    const renderColumnContent = (columndivision, styleSheet, renderLinks) => {
      const header = blockdivision?.columndivision?.field;
      return Object.keys(columndivision).map((columnKey) => {
        if (columnKey === "field") {
          let fieldArray = columndivision.field ? columndivision.field : [];
          if (!Array.isArray(fieldArray)) {
            fieldArray = [fieldArray];
          }

          if (
            styleSheet &&
            styleSheet.noTransformColumnsIntoRow &&
            !renderLinks &&
            !styleSheet.transformLinksIntoWrapper
          ) {
            /*novobanco, finantia*/
            return fieldArray.map((field, index) => {
              return (
                <div
                  key={`col_${uuid()}`}
                  style={{
                    flexBasis: `${
                      columndivision.width ? columndivision.width : "100"
                    }%`,
                  }}
                >
                  {renderFields(field, index)}
                </div>
              );
            });
          } else if (
            styleSheet &&
            styleSheet.applyColumnWidth &&
            !styleSheet.noTransformColumnsIntoRow
          ) {
            /*cma*/

            fieldArray = fieldArray.filter(function (obj) {
              return obj.type !== "filler";
            });

            return fieldArray.map((field, index) => {
              return (
                <div
                  key={`col_${uuid()}`}
                  style={{
                    flexBasis: `${
                      columndivision.width ? columndivision.width : "100"
                    }%`,
                    maxWidth: `${
                      columndivision.width ? columndivision.width : "100"
                    }%`,
                    paddingLeft: field.type === "link" ? "15px" : "",
                  }}
                >
                  {renderFields(field, index)}
                </div>
              );
            });
          } else
          /*default*/
            return fieldArray.map((field, index) => renderFields(field, index));

          /*RENDER tabdivision*/
        } else if (columnKey === "tabdivision") {
          let tabDivisionArray = columndivision.tabdivision
            ? columndivision.tabdivision
            : [];
          if (!Array.isArray(tabDivisionArray)) {
            tabDivisionArray = [tabDivisionArray];
          }
          let accordionStyle = "DEFAULT";

          const accordion = tabDivisionArray.map((tabDiv) => {
            let tabArray = tabDiv.tab ? tabDiv.tab : [];
            if (!Array.isArray(tabArray)) tabArray = [tabArray];
            tabArray.forEach((tab) => {
              if (tab.name.includes("::tab")) accordionStyle = "TAB";
            });

            if (accordionStyle === "TAB") {
              return (
                <CreateTabs
                  key={uuid()}
                  tabDiv={tabDiv}
                  tabArray={tabArray}
                  renderBlockDivision={renderBlockDivision}
                />
              );
            } else {
              let activeKey = 0;
              //find active tab
              let arrays =
                JSON.parse(localStorage.getItem("iflowAccordion")) || [];
              //find config for this tabDiv
              let found = arrays.find((a) => a.id === tabDiv.id);
              if (found) {
                tabArray.forEach((tab, index) => {
                  if (tab.id === found.key) {
                    activeKey = found.key;
                  }
                });
              }
              return (
                <CreateAccordion
                  key={uuid()}
                  tabDiv={tabDiv}
                  activeKey={activeKey}
                  tabArray={tabArray}
                  renderBlockDivision={renderBlockDivision}
                  renderColumnContent={renderColumnContent}
                  header={header}
                  flowId={getFlowId()}
                  styleSheet={styleSheet}
                />
              );
            }
          });
          return accordion;
        }
      });
    };

    const transformColumnsIntoRow = (columns_) => {
      let colIndex = 0;
      colIndex = columns_.findIndex(
        (col) =>
          col && //null and undefined check
          col !== "" &&
          Object.keys(col).length !== 0
      );
      return Object.keys(columns_[colIndex]).map((columnKey) => {
        if (columnKey === "field") {
          let fieldArray = columns_[colIndex].field
            ? columns_[colIndex].field
            : [];
          if (!Array.isArray(fieldArray)) {
            fieldArray = [fieldArray];
          }

          return fieldArray.map((field, index) => {
            if (index > 0) return renderFields(field, index);
            else if (index === 0) {
              return (
                <CreateRowFromColumns
                  key={index}
                  field={field}
                  columns={columns_}
                  styleSheet={styleSheet}
                />
              );
            }
          });
        }
      });
    };

    let columndivision = blockdivision.columndivision;
    if (!Array.isArray(columndivision)) {
      columndivision = [columndivision];
    }
    let numColumns = columndivision.length;

    if (numColumns === 1) {
      return (
        <Col key={`columndivision_${uuid()}`} style={{ flexGrow: "1" }}>
          {renderColumnContent(
            columndivision[0],
            styleSheet,
            hasLinks(columndivision)
          )}
        </Col>
      );
    } else if (numColumns > 1) {
      if (
        styleSheet &&
        (styleSheet.noTransformColumnsIntoRow ||
          (hasLinks(columndivision) && styleSheet?.transformLinksIntoWrapper))
      ) {
        return (
          <div
            key={`columndivision_${uuid()}`}
            style={{
              display: "flex",
              flexWrap: styleSheet?.transformLinksIntoWrapper
                ? "wrap"
                : "nowrap",
              flexDirection: "row",
              flexGrow: "1",
              padding: "0 15px",
              justifyContent:
                hasLinks(columndivision) &&
                styleSheet?.transformLinksIntoWrapper
                  ? "center"
                  : "",
            }}
          >
            {columndivision.map((col) => {
              return renderColumnContent(col, styleSheet);
            })}
          </div>
        );
      } else if (
        styleSheet &&
        styleSheet.applyColumnWidth &&
        !styleSheet.noTransformColumnsIntoRow
      ) {
        return (
          <div
            key={`columndivision_${uuid()}`}
            style={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: "row",
              flexGrow: "1",
              padding: "0 15px",
              maxWidth: "100%",
              // marginTop: "1rem",
              // marginBottom: "1rem",
              // border: "0",
              // borderBottom: "1px solid rgba(0,0,0,.1)",
            }}
          >
            {columndivision.map((col) => {
              return renderColumnContent(col, styleSheet);
            })}
          </div>
        );
      } else
        return (
          <Col key={`columndivision_${uuid()}`} style={{ flexGrow: "1" }}>
            {transformColumnsIntoRow(columndivision)}
          </Col>
        );
    }
  };

  const renderBlockDivision = (blockdivision) => {
    let blockdivisionArray = blockdivision;
    if (!Array.isArray(blockdivisionArray)) {
      blockdivisionArray = [blockdivisionArray];
    }
    return blockdivisionArray.map((blockdivision, index) => {
      console.log(Array.isArray(blockdivision?.columndivision));
      return (
        <Row
          key={`blockdivision_${index}`}
          style={{
            width: "100%",
            flexWrap: "nowrap",
            margin: "0px",
            padding: styleSheet?.compact
              ? "0px"
              : blockdivision?.columndivision === ""
              ? "0px"
              : Array.isArray(blockdivision?.columndivision)
              ? blockdivision?.columndivision[0]?.size > 0
                ? "5px"
                : "0px"
              : "5px",
          }}
        >
          {renderColumnDivisions(blockdivision, index)}
        </Row>
      );
    });
  };

  const RenderFormItems = () => {
    if (jsonData) {
      const form = jsonData.form;
      return Object.keys(form).map((formKey) => {
        if (formKey === "blockdivision") {
          return renderBlockDivision(form.blockdivision);
        }
        if (formKey === "error") {
          let text = form.error?.text.split("<br/>");
          return (
            <Row
              key={`blockdivision_error`}
              style={{
                width: "100%",
                flexWrap: "nowrap",
                margin: "0px",
                padding: "5px",
              }}
            >
              <Col key={`columndivision_error`} style={{ flexGrow: "1" }}>
                <Alert key={formKey} variant="danger">
                  {text &&
                    text.map((p_, index) => {
                      return <p key={index}>{p_}</p>;
                    })}
                </Alert>
              </Col>
            </Row>
          );
        }
        if (formKey === "button") {
          let buttonArray = form.button ? form.button : [];
          if (!Array.isArray(buttonArray)) {
            buttonArray = [buttonArray];
          }
          return (
            <Row
              style={{
                display: "flex",
                justifyContent: "center",
                paddingTop: "65px",
              }}
              key={uuid()}
            >
              {buttonArray.map((button) => {
                if (button.text === "Cancelar" || button.text === "Cancel") {
                  if (button?.zotooltipna) {
                    return (
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip(button.tooltip)}
                      >
                        <Button
                          key={uuid()}
                          id={button.id}
                          variant="danger"
                          style={{ margin: "10px" }}
                          onClick={(event) =>
                            handleSubmitWrapper(event, button)
                          }
                        >
                          {button.text}
                        </Button>
                      </OverlayTrigger>
                    );
                  } else {
                    return (
                      <Button
                        key={uuid()}
                        id={button.id}
                        variant="danger"
                        style={{ margin: "10px" }}
                        onClick={(event) => handleSubmitWrapper(event, button)}
                      >
                        {button.text}
                      </Button>
                    );
                  }
                } else {
                  if (button?.tooltip) {
                      return (
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderTooltip(button?.tooltip)}
                        >
                          <Button
                            key={uuid()}
                            id={button.id}
                            className="card-button"
                            style={{ margin: "10px" }}
                            onClick={(event) => {
                              handleSubmitWrapper(event, button);
                            }}
                          >
                            {button.text}
                          </Button>
                        </OverlayTrigger>
                      );
                  } else {
                    return (
                      <Button
                        key={uuid()}
                        id={button.id}
                        className="card-button"
                        style={{ margin: "10px" }}
                        onClick={(event) => handleSubmitWrapper(event, button)}
                      >
                        {button.text}
                      </Button>
                    );
                  }
                }
              })}
            </Row>
          );
        }
        if (formKey === "hidden") {
          const hiddenArray = form.hidden;
          return hiddenArray.map((field, index) => {
            return (
              <input
                key={index}
                type="hidden"
                value={field.value}
                name={field.name}
              />
            );
          });
        }
      });
    } else return null;
  };

  return (
    <>
      {!props.isModal && styleSheet?.processCloseButton && (
        <CreateCloseProcessButton />
      )}
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        name="dados"
        encType="multipart/form-data"
        style={{
          width: "100%",
          margin: "auto",
        }}
        className="process-form"
      >
        {jsonData && <RenderFormItems />}
      </Form>
      <CreateConfirmationModal
        handleCancelSubmit={handleCancelSubmit}
        handleConfirm={handleConfirm}
      />
      <Messages />
    </>
  );
};

export default withNamespaces()(RenderForm);
